import { render, staticRenderFns } from "./bindingLogistics.vue?vue&type=template&id=636a5c72"
import script from "./bindingLogistics.vue?vue&type=script&lang=js"
export * from "./bindingLogistics.vue?vue&type=script&lang=js"
import style0 from "./bindingLogistics.vue?vue&type=style&index=0&id=636a5c72&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports